import React, { Component } from 'react';
import MalidCard from './MalidCard';

class RussneskaView extends Component {
	formatHtml(html) {
		let formatted = html.split('<LIÐUR>').join('<br/><strong>').split('</LIÐUR>').join('</strong> ')
			.split('<RUS>').join('<span>').split('</RUS>').join('</span><br/>')
			.split('<FRASI>').join('<em><strong>').split('</FRASI>').join('</strong></em><br/>')
			.split('<DÆMI>').join('<em><strong>').split('</DÆMI>').join('</strong></em><br/>')

		if (formatted.substr(0, 13) === '<br/><strong>') {
			formatted = formatted.substr(5);
		}

		return formatted;
	}

	render() {
		return (
			<MalidCard title={window.l('russneska_title')}
				subTitle={'1962'}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				database="russneska"
				aboutText={window.l('russneska_about')}
				className="truncated">
				{
					this.props.data && this.props.data.map((item, index) => {

						return <React.Fragment key={index}>
							{
								index > 0 && <hr className="divider"/>
							}
							<p className={'card-text'+(item.html.length > 1000 ? ' preview' : '')}>
								<a target='_blank' href={'https://ymsir.arnastofnun.is/russ/russ?ord='+item.id}><strong>{item.fletta}</strong></a> {item.ofl}<br/><br/>
								<span className="" dangerouslySetInnerHTML={{__html: this.formatHtml(item.html)}} />
							</p>
							<p className="card-text">
								<a target='_blank' href={'https://ymsir.arnastofnun.is/russ/russ?ord='+item.id} className="text-light">Sjá færslu í orðabók</a>
							</p>
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default RussneskaView;



// WEBPACK FOOTER //
// ./src/components/RussneskaView.js